// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';

/**
 * Converts data like "10 minutes" into 600
 * @param {Integer|String} amount The amount of time
 * @param {String}         unit The unit of time
 * 
 * @return {Integer} The time in seconds
 */
const convertDelayToSeconds = ( amount, unit ) => {
	// Check if the amount is a number
	amount = parseInt( amount );

	if ( isNaN( amount ) ) {
		return;
	}

	// Define multipliers
	const multipliers = {
		'seconds': 1,
		'minutes': 60,
		'hours':   3600,
		'days':    86400,
		'years':   31536000
	}

	// Check if the unit is valid
	if ( ! isDefined( multipliers[ unit ] ) ) {
		return;
	}

	return amount * multipliers[ unit ];
}

export default convertDelayToSeconds;
